// src/pages/AccountPage.jsx
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, orderBy } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import { useAuth } from "../context/AuthContext";
import "./AccountPage.css";

const PROFILE_CA_PROVINCES = [["AB","Alberta"],["BC","British Columbia"],["MB","Manitoba"],["NB","New Brunswick"],["NL","Newfoundland and Labrador"],["NS","Nova Scotia"],["NT","Northwest Territories"],["NU","Nunavut"],["ON","Ontario"],["PE","Prince Edward Island"],["QC","Quebec"],["SK","Saskatchewan"],["YT","Yukon"]];
const PROFILE_US_STATES = [["AL","Alabama"],["AK","Alaska"],["AZ","Arizona"],["AR","Arkansas"],["CA","California"],["CO","Colorado"],["CT","Connecticut"],["DE","Delaware"],["DC","District of Columbia"],["FL","Florida"],["GA","Georgia"],["HI","Hawaii"],["ID","Idaho"],["IL","Illinois"],["IN","Indiana"],["IA","Iowa"],["KS","Kansas"],["KY","Kentucky"],["LA","Louisiana"],["ME","Maine"],["MD","Maryland"],["MA","Massachusetts"],["MI","Michigan"],["MN","Minnesota"],["MS","Mississippi"],["MO","Missouri"],["MT","Montana"],["NE","Nebraska"],["NV","Nevada"],["NH","New Hampshire"],["NJ","New Jersey"],["NM","New Mexico"],["NY","New York"],["NC","North Carolina"],["ND","North Dakota"],["OH","Ohio"],["OK","Oklahoma"],["OR","Oregon"],["PA","Pennsylvania"],["RI","Rhode Island"],["SC","South Carolina"],["SD","South Dakota"],["TN","Tennessee"],["TX","Texas"],["UT","Utah"],["VT","Vermont"],["VA","Virginia"],["WA","Washington"],["WV","West Virginia"],["WI","Wisconsin"],["WY","Wyoming"]];

const PackageIcon    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16.5 9.4l-9-5.19"/><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/><polyline points="3.29 7 12 12 20.71 7"/><line x1="12" y1="22" x2="12" y2="12"/></svg>;
const UserIcon       = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const MapPinIcon     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>;
const ShoppingBagIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;
const CartIcon       = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>;
const LogOutIcon     = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>;
const CheckIcon      = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="m9 11 3 3L22 4"/></svg>;
const InboxIcon      = () => <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/></svg>;
const TruckIcon      = () => <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><circle cx="7" cy="21" r="2"/><path d="M9 21h6"/><circle cx="17" cy="21" r="2"/><path d="M17 3v5h2a2 2 0 0 1 2 2v7"/></svg>;

const TABS = [
  { key: "Orders",    label: "My Orders", Icon: PackageIcon },
  { key: "Profile",   label: "Profile",   Icon: UserIcon    },
  { key: "Addresses", label: "Address",   Icon: MapPinIcon  },
];

// Status config — matches what Sinalite + our system returns
const STATUS_CONFIG = {
  processing:      { bg: "#fef9c3", color: "#854d0e",  label: "Processing" },
  "in-production": { bg: "#f3e8ff", color: "#7e22ce",  label: "In Production" },
  dispatched:      { bg: "#dcfce7", color: "#166534",  label: "Dispatched" },
  delivered:       { bg: "#d1fae5", color: "#065f46",  label: "Delivered" },
  cancelled:       { bg: "#fee2e2", color: "#991b1b",  label: "Cancelled" },
};

function OrderStatusBadge({ status }) {
  var s = STATUS_CONFIG[status] || STATUS_CONFIG.processing;
  return (
    <span style={{ background: s.bg, color: s.color, padding: "3px 10px", borderRadius: 20, fontSize: 12, fontWeight: 700 }}>
      {s.label}
    </span>
  );
}

// Progress bar steps
const STATUS_STEPS = ["processing", "in-production", "dispatched", "delivered"];

function OrderProgressBar({ status }) {
  if (status === "cancelled") return (
    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 10 }}>
      <span style={{ color: "#f87171", fontSize: 13, fontWeight: 600 }}>❌ Order Cancelled</span>
    </div>
  );
  var current = STATUS_STEPS.indexOf(status);
  return (
    <div style={{ marginTop: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 0 }}>
        {STATUS_STEPS.map((step, i) => {
          var done = i <= current;
          var active = i === current;
          return (
            <div key={step} style={{ display: "flex", alignItems: "center", flex: i < STATUS_STEPS.length - 1 ? 1 : "none" }}>
              <div style={{
                width: 28, height: 28, borderRadius: "50%", flexShrink: 0,
                background: done ? "var(--cyan, #00aadd)" : "rgba(0,0,0,0.08)",
                border: active ? "2px solid var(--cyan, #00aadd)" : done ? "none" : "2px solid #e5e7eb",
                display: "flex", alignItems: "center", justifyContent: "center",
                color: done ? "#fff" : "#9ca3af", fontSize: 12, fontWeight: 700,
                transition: "all 0.3s",
              }}>
                {done ? "✓" : i + 1}
              </div>
              {i < STATUS_STEPS.length - 1 && (
                <div style={{ flex: 1, height: 3, background: i < current ? "var(--cyan, #00aadd)" : "#e5e7eb", transition: "background 0.3s" }} />
              )}
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6 }}>
        {STATUS_STEPS.map(step => (
          <span key={step} style={{ fontSize: 10, color: "#6b7280", textAlign: "center", width: 28, lineHeight: 1.2, textTransform: "capitalize" }}>
            {STATUS_CONFIG[step]?.label.split(" ")[0]}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function AccountPage() {
  const [activeTab, setActiveTab]         = useState("Orders");
  const [orders, setOrders]               = useState([]);
  const [ordersLoading, setOrdersLoading] = useState(true);
  const [profileForm, setProfileForm]     = useState({ fullName: "", phone: "", address: "", city: "", state: "", postcode: "", country: "CA", notificationEmail: "" });
  const [saving, setSaving]               = useState(false);
  const [saved, setSaved]                 = useState(false);

  const { user, profile, logout, updateUserProfile } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (profile) {
      setProfileForm({
        fullName: profile.fullName || "",
        phone:    profile.phone    || "",
        address:  profile.address  || "",
        city:     profile.city     || "",
        state:    profile.state    || "",
        country:  profile.country  || "CA",
        postcode: profile.postcode || "",
        notificationEmail: profile.notificationEmail || "", // Override billing email for Sinalite communications
      });
    }
  }, [profile]);

  useEffect(() => {
    if (!user) return;
    async function fetchOrders() {
      try {
        // Query by userId (new Sinalite orders)
        var q = query(
          collection(db, "orders"),
          where("userId", "==", user.uid),
          orderBy("createdAt", "desc")
        );
        var snap = await getDocs(q);
        var results = snap.docs.map(d => ({ id: d.id, ...d.data() }));

        // Fallback: also try customerEmail (old orders)
        if (results.length === 0) {
          var q2 = query(collection(db, "orders"), where("customerEmail", "==", user.email));
          var snap2 = await getDocs(q2);
          results = snap2.docs.map(d => ({ id: d.id, ...d.data() }));
        }
        setOrders(results);
      } catch {
        setOrders([]);
      } finally {
        setOrdersLoading(false);
      }
    }
    fetchOrders();
  }, [user]);

  async function handleLogout() {
    await logout();
    navigate("/");
  }

  async function handleProfileSave(e) {
    e.preventDefault();
    setSaving(true);
    try {
      await updateUserProfile(profileForm);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (err) { alert(err.message || "Could not save your profile."); }
  }

  var displayName = profile?.fullName || user?.displayName || user?.email?.split("@")[0] || "User";
  var initial = displayName[0]?.toUpperCase() || "U";

  return (
    <div className="account-page">
      <div className="container account-layout">

        {/* Sidebar */}
        <div className="account-sidebar">
          <div className="account-avatar-box">
            <div className="account-avatar">{initial}</div>
            <div>
              <strong>{displayName}</strong>
              <span>{user?.email}</span>
            </div>
          </div>
          <nav className="account-nav">
            {TABS.map(t => (
              <button key={t.key}
                className={"account-nav-btn" + (activeTab === t.key ? " active" : "")}
                onClick={() => setActiveTab(t.key)}>
                <span className="account-nav-icon"><t.Icon /></span>
                {t.label}
              </button>
            ))}
          </nav>
          <div className="account-sidebar-links">
            <Link to="/products" className="account-sidebar-link"><span className="account-nav-icon"><ShoppingBagIcon /></span> Shop Products</Link>
            <Link to="/cart" className="account-sidebar-link"><span className="account-nav-icon"><CartIcon /></span> View Cart</Link>
            <button className="account-sidebar-link account-logout-btn" onClick={handleLogout}>
              <span className="account-nav-icon"><LogOutIcon /></span> Sign Out
            </button>
          </div>
        </div>

        {/* Main */}
        <div className="account-main">

          {/* ORDERS TAB */}
          {activeTab === "Orders" && (
            <div>
              <h2 className="account-section-title">My Orders</h2>
              {ordersLoading ? (
                <div className="account-loading">Loading orders...</div>
              ) : orders.length === 0 ? (
                <div className="account-empty">
                  <div className="account-empty-icon"><InboxIcon /></div>
                  <p>No orders yet.</p>
                  <Link to="/products" className="btn-primary">Start Shopping</Link>
                </div>
              ) : (
                <div className="orders-list">
                  {orders.map(order => {
                    var ship = order.shippingInfo || {};
                    var date = order.createdAt?.toDate
                      ? order.createdAt.toDate().toLocaleDateString("en-CA", { day: "numeric", month: "short", year: "numeric" })
                      : "—";
                    var items = order.cartItems || [];

                    return (
                      <div key={order.id} className="order-card">
                        {/* Top row */}
                        <div className="order-card-top">
                          <div>
                            <strong className="order-product-name">
                              {items.length} item{items.length !== 1 ? "s" : ""}
                            </strong>
                            <span className="order-date">{date}</span>
                          </div>
                          <OrderStatusBadge status={order.status || "processing"} />
                        </div>

                        {/* Progress bar */}
                        <OrderProgressBar status={order.status || "processing"} />

                        {/* Tracking number — shown prominently when available */}
                        {order.trackingNumber && (
                          <div style={{
                            marginTop: 14,
                            padding: "10px 14px",
                            background: "rgba(74,222,128,0.08)",
                            border: "1.5px solid rgba(74,222,128,0.3)",
                            borderRadius: 8,
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}>
                            <TruckIcon />
                            <div>
                              <span style={{ fontSize: 11, fontWeight: 700, color: "#4ade80", textTransform: "uppercase", letterSpacing: "0.05em" }}>
                                Tracking Number
                              </span>
                              <p style={{ fontFamily: "monospace", fontWeight: 700, fontSize: 14, margin: "2px 0 0", color: "var(--text)" }}>
                                {order.trackingNumber}
                              </p>
                            </div>
                          </div>
                        )}

                        {/* Order meta */}
                        <div className="order-card-details" style={{ marginTop: 14 }}>
                          {order.sinaliteOrderId && (
                            <span>
                              Order ID: <strong style={{ fontFamily: "monospace" }}>#{order.sinaliteOrderId}</strong>
                            </span>
                          )}
                          {ship.ShipMethod && (
                            <span><TruckIcon /> <strong>{ship.ShipMethod}</strong></span>
                          )}
                          {order.amount && (
                            <span>Total: <strong>${(order.amount / 100).toFixed(2)}</strong></span>
                          )}
                          {order.statusUpdatedAt?.toDate && (
                            <span style={{ fontSize: 11, color: "var(--text-muted)" }}>
                              Updated: {order.statusUpdatedAt.toDate().toLocaleDateString("en-CA", { day: "numeric", month: "short" })}
                            </span>
                          )}
                        </div>

                        {/* Delivery address */}
                        {ship.ShipAddr && (
                          <p style={{ fontSize: 13, color: "var(--gray)", marginTop: 8 }}>
                            📍 {ship.ShipAddr}, {ship.ShipCity}, {ship.ShipState} {ship.ShipZip}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          )}

          {/* PROFILE TAB */}
          {activeTab === "Profile" && (
            <div>
              <h2 className="account-section-title">My Profile</h2>
              <form onSubmit={handleProfileSave} className="profile-form">
                <div className="profile-form-grid">
                  <div className="form-group">
                    <label>Full Name</label>
                    <input value={profileForm.fullName} onChange={e => setProfileForm(p => ({ ...p, fullName: e.target.value }))} placeholder="John Smith" />
                  </div>
                  <div className="form-group">
                    <label>Email Address</label>
                    <input value={user?.email || ""} disabled className="input-disabled" />
                  </div>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <input value={profileForm.phone} onChange={e => setProfileForm(p => ({ ...p, phone: e.target.value }))} placeholder="416-555-0100" />
                  </div>
                </div>
                
                {/* Notification Email — Override billing email for Sinalite communications */}
                <div style={{ marginTop: 20, paddingTop: 20, borderTop: "1px solid rgba(0,0,0,0.08)" }}>
                  <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                    <label>Notification Email (Optional)</label>
                    <input 
                      type="email"
                      value={profileForm.notificationEmail} 
                      onChange={e => setProfileForm(p => ({ ...p, notificationEmail: e.target.value }))} 
                      placeholder="Enter email for order notifications (leave blank for default)" 
                    />
                    <p style={{ fontSize: 12, color: "rgba(0,0,0,0.5)", marginTop: 6 }}>
                      ℹ️ If set, all order confirmations, proofs, and shipping notifications will be sent to this email instead of the company email.
                    </p>
                  </div>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 20 }}>
                  <button type="submit" className="btn-primary" disabled={saving}>{saving ? "Saving..." : "Save Changes"}</button>
                  {saved && <span className="profile-saved"><CheckIcon /> Saved!</span>}
                </div>
              </form>
            </div>
          )}

          {/* ADDRESSES TAB */}
          {activeTab === "Addresses" && (
            <div>
              <h2 className="account-section-title">Delivery Address</h2>
              <form onSubmit={handleProfileSave} className="profile-form">
                <div className="profile-form-grid">
                  <div className="form-group" style={{ gridColumn: "1 / -1" }}>
                    <label>Street Address</label>
                    <input value={profileForm.address} onChange={e => setProfileForm(p => ({ ...p, address: e.target.value }))} placeholder="123 Main Street" />
                  </div>
                  <div className="form-group">
                    <label>City / Town</label>
                    <input value={profileForm.city} onChange={e => setProfileForm(p => ({ ...p, city: e.target.value }))} placeholder="Toronto" />
                  </div>
                  <div className="form-group">
                    <label>Country</label>
                    <select value={profileForm.country} onChange={e => setProfileForm(p => ({ ...p, country: e.target.value, state: "" }))}>
                      <option value="CA">Canada</option>
                      <option value="US">United States</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Province / State</label>
                    <select value={profileForm.state} onChange={e => setProfileForm(p => ({ ...p, state: e.target.value }))}>
                      <option value="">Select</option>
                      {(profileForm.country === "US" ? PROFILE_US_STATES : PROFILE_CA_PROVINCES).map(s => <option key={s[0]} value={s[0]}>{s[1]}</option>)}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Postal / ZIP Code</label>
                    <input value={profileForm.postcode} onChange={e => setProfileForm(p => ({ ...p, postcode: e.target.value }))} placeholder="M5V 1A1" />
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 14, marginTop: 8 }}>
                  <button type="submit" className="btn-primary" disabled={saving}>{saving ? "Saving..." : "Save Address"}</button>
                  {saved && <span className="profile-saved"><CheckIcon /> Saved!</span>}
                </div>
              </form>
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
